import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';

import type { InterventionCenterStatistics as InterventionCenterStatisticsType } from '../../../common/types/statistics/fhbfStatistics';
import OptionStatistic from './OptionStatistic';
import policeMeasureForm from '../../../clients/detail/fhbfForm/interventionCenter/policeMeasureForm';

type Props = {
  statistics: InterventionCenterStatisticsType;
};

function CounselingStatistics({ statistics }: Props) {
  return (
    <Paper
      variant='outlined'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        margin: '24px 0',
        padding: '20px 24px',
        maxWidth: '650px',
        minWidth: '300px',
        backgroundColor: '#FAFAFA',
      }}
    >
      <Stack direction='column'>
        <Typography fontSize='1.2rem' fontWeight='bold' mb={2}>
          Beratung der von Gewalt betroffenen Frauen
        </Typography>
        <Typography>Anzahl der Frauen, die beraten wurden: {statistics.numberOfWomenAdvised}</Typography>
        <Typography>Anzahl der Beratungen insgesamt: {statistics.totalNumberOfMeasures}</Typography>
        <Typography>Davon Beratungen mit Dolmetschung: {statistics.numberOfTranslation}</Typography>
        <Typography>Risikofragebogen: {statistics.numberOfRiskQuestionnaire}</Typography>
        <Typography>Beratungstermine bis 30 Minuten: {statistics.durationUpToThirtyMinutes}</Typography>
        <Typography>
          Beratungstermine zwischen 30 - 60 Minuten: {statistics.durationBetweenThirtyOneAndSixtyMinutes}
        </Typography>
        <Typography>
          Beratungstermine zwischen 61 - 90 Minuten: {statistics.durationBetweenSixtyOneAndNinetyMinutes}
        </Typography>
        <Typography>Beratungstermine über 90 Minuten: {statistics.durationOverNintyMinutes}</Typography>
        <Typography>Anzahl der Kurzkontake: {statistics.numberOfContactAttempts}</Typography>
        <Typography>
          Anzahl der Frauen mit keinen Beratungswunsch: {statistics.numberOfNoConsultationRequest}
        </Typography>
        <Stack my={1}>
          <Typography fontWeight='bold'>Anzahl der Art der Beratungen</Typography>
          <Typography>Telefonische Beratungen: {statistics.numberOfTypeTelephoneConsultation}</Typography>
          <Typography>Persönliche Beratungen: {statistics.numberOfTypePersonalConsultation}</Typography>
          <Typography>Online Beratungen: {statistics.numberOfTypeOnlineConsultation}</Typography>
          <Typography>Follow Up: {statistics.numberOfTypeFollowUp}</Typography>
        </Stack>
        <Stack my={1}>
          <Typography fontWeight='bold'>Anzahl Beratungen zu den Themen</Typography>
          <Typography>Häusliche Gewalt: {statistics.numberOfTopicDomesticViolence}</Typography>
          <Typography>Stalking: {statistics.numberOfTopicStalking}</Typography>
          <Typography>Mobbing: {statistics.numberOfTopicBullying}</Typography>
          <Typography>FGM: {statistics.numberOfTopicFgm}</Typography>
          <Typography>Psychosozialen Beratungen: {statistics.numberOfTopicPsychosocialCounseling}</Typography>
          <Typography>Traumafachberatungen: {statistics.numberOfTopicTraumaCounseling}</Typography>
          <Typography>Sonstige Themen: {statistics.numberOfTopicOther}</Typography>
        </Stack>
        <Stack my={1}>
          <Typography fontWeight='bold'>Anzahl der Frauen mit x Beratungsterminen</Typography>
          <Typography>1 Beratungstermin: {statistics.numberOfWomenWithOneMeasure}</Typography>
          <Typography>2 Beratungstermine: {statistics.numberOfWomenWithTwoMeasures}</Typography>
          <Typography>3 Beratungstermine: {statistics.numberOfWomenWithThreeMeasures}</Typography>
          <Typography>4 Beratungstermine: {statistics.numberOfWomenWithFourMeasures}</Typography>
          <Typography>5 Beratungstermine und mehr: {statistics.numberOfWomenWithFiveAndMoreMeasures}</Typography>
        </Stack>
      </Stack>
    </Paper>
  );
}

export default CounselingStatistics;
